import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>User-Centric Custom Software Development in Dallas</h2>
            </div>
            <p>
              TekRevol is a premier technology company for custom software
              development in Dallas, building extraordinary user experiences by
              implementing a user-centric design and development philosophy. Our
              proactive approach towards problem-solving and implementation of
              Agile development practices helps us create custom software that
              addresses the needs of a business.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
